/* Xeist — attach the Downpay 50% deposit selling plan to the KitBuilder
 * cart line after the customizer handoff.
 *
 * Why this exists: Downpay deposits work through Shopify selling plans
 * (purchase options). KitBuilder adds its dynamically-created variant to the
 * cart WITHOUT a selling plan, so the choice made on the customizer can't
 * ride along. The customizer writes a localStorage flag at submit time;
 * this script (cart page only) reads it, finds the KitBuilder line, looks up
 * the product's deposit selling plan, and re-applies the line with it.
 *
 * Scope guard: only the customizer ever writes the flag, and only lines
 * whose product carries a deposit-style selling plan are touched — normal
 * DTC products are never affected.
 */
(function () {
  if (window.location.pathname.indexOf('/cart') !== 0) return;

  var APPLY_KEY = 'xeist_apply_deposit_at_cart';
  var GUARD_KEY = 'xeist_deposit_apply_done';
  var FLAG_MAX_AGE_MS = 30 * 60 * 1000; /* ignore flags older than 30 min */

  var raw;
  try { raw = window.localStorage.getItem(APPLY_KEY); } catch (e) { return; }
  if (!raw) return;

  var flag;
  try { flag = JSON.parse(raw); } catch (e) { flag = null; }

  function clearFlag() {
    try { window.localStorage.removeItem(APPLY_KEY); } catch (e) { /* noop */ }
  }

  if (!flag || !flag.want || (Date.now() - (flag.ts || 0)) > FLAG_MAX_AGE_MS) {
    clearFlag();
    return;
  }

  /* Re-entry guard: cart reloads after a successful apply. */
  try {
    if (window.sessionStorage.getItem(GUARD_KEY) === String(flag.ts)) {
      clearFlag();
      return;
    }
  } catch (e) { /* noop */ }

  function findDepositPlan(product) {
    var groups = (product && product.selling_plan_groups) || [];
    for (var g = 0; g < groups.length; g++) {
      var plans = groups[g].selling_plans || [];
      for (var p = 0; p < plans.length; p++) {
        var name = ((groups[g].name || '') + ' ' + (plans[p].name || '')).toLowerCase();
        if (/deposit|50\s*%|partial/.test(name)) return plans[p].id;
      }
    }
    return null;
  }

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var items = cart.items || [];
      /* The KitBuilder line: newest line (index 1) without a selling plan.
         Verify by looking up its product's selling plans before touching it. */
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.selling_plan_allocation) continue; /* already on a plan */
        (function (lineIndex, lineItem) {
          /* KitBuilder creates a brand-new product seconds before the
             customer reaches the cart, and Downpay's tag-based rule attaches
             the selling plan asynchronously — so the plan may not exist on
             first look. Retry briefly before giving up. */
          var PLAN_RETRIES = 5;
          var PLAN_RETRY_DELAY_MS = 4000;

          function fetchPlanWithRetry(attempt) {
            return fetch('/products/' + lineItem.handle + '.js')
              .then(function (r) { return r.json(); })
              .then(function (product) {
                var planId = findDepositPlan(product);
                if (planId) return planId;
                if (attempt >= PLAN_RETRIES) return null;
                return new Promise(function (res) {
                  setTimeout(function () { res(fetchPlanWithRetry(attempt + 1)); }, PLAN_RETRY_DELAY_MS);
                });
              });
          }

          fetchPlanWithRetry(1)
            .then(function (planId) {
              if (!planId) return; /* no deposit option on this product — leave it alone */
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  line: lineIndex + 1,
                  quantity: lineItem.quantity,
                  selling_plan: planId
                })
              }).then(function (r) {
                if (!r.ok) throw new Error('cart/change failed: ' + r.status);
                clearFlag();
                try { window.sessionStorage.setItem(GUARD_KEY, String(flag.ts)); } catch (e) { /* noop */ }
                window.location.reload();
              });
            })
            .catch(function (err) {
              /* Fail open: the order proceeds as pay-in-full rather than
                 blocking checkout over a deposit decoration. */
              clearFlag();
              if (window.console && console.warn) {
                console.warn('[Xeist deposit] could not apply deposit plan:', err);
              }
            });
        })(i, item);
      }
    })
    .catch(function () { clearFlag(); });
})();
